import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleApiError, setAuthHeader } from '../../helpers';
import { USER_KEY } from '../../helpers/constants';
import history from '../../helpers/history';
import { AuthenthicatedUserInfo } from '../../interfaces';
import { completeProfile } from '../../states/action_creators';
import useResetError from '../useResetError';

export const useCreateServiceProvider = () => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { error, setError } = useResetError();
  const dispatch = useDispatch();

  const onSubmitHandler = (values: any) => {
    console.log(values, 'valuess ===================');
    const user: AuthenthicatedUserInfo = JSON.parse(localStorage.getItem(USER_KEY)!);

    // API CALL SHOULD HAPPEN HERE

    const updatedUser = { ...user, profileCompleted: true };
    dispatch(completeProfile(updatedUser));
    history.push('/dashboard');
  };

  return { submitting, error, onSubmitHandler };
};
